import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useNotify } from '@/hooks'
import { CreateSellTreezRequest } from '@/models/sellTreez'
import { SellTreezService } from '@/services/sell-treez'

const useCreateSellTreez = (onSuccess?: () => void) => {
  const { notifySuccess, notifyError } = useNotify()
  const queryClient = useQueryClient()

  const create = async (data: CreateSellTreezRequest): Promise<boolean> => {
    const response = await SellTreezService.createSellTreez(data)
    return Boolean(response.data)
  }

  const { mutate: createSellTreez, isPending: isCreating } = useMutation({
    mutationFn: create,
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['all-sell-treez'] })
      onSuccess?.()
      notifySuccess('SellTreez created successfully')
    },
    onError: (error) => {
      console.error('Error creating SellTreez:', error)
      notifyError(`Error creating SellTreez`)
    },
  })

  return { createSellTreez, isCreating }
}

export { useCreateSellTreez }
